import {DateTime} from 'luxon';

const getDateWithoutTime = (dateTime: DateTime) =>
    dateTime.set({hour: 0, minute: 0, second: 0, millisecond: 0});

    

export default getDateWithoutTime;
